import React from 'react';
import { Navbar, Container } from 'reactstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ReactGA from 'react-ga';

import { getAbout } from '../actions/AboutActions';

class About extends React.Component {
  componentWillMount() {
    ReactGA.pageview('/QuienesSomos');
    this.props.getAbout();
  }

  _goBack() {
    this.props.history.goBack();
  }

  render() {
    return (
      <div className="sp-page">
        <Navbar className="sp-nav">
          {/* <div className="sp-bk ico-sp-cvleft" onClick={() => this._goBack()}></div> */}
          <div className="sp-label">¿Quienes Somos?</div>
          <div>&nbsp;</div>
        </Navbar>
        <Container className="sp-content p-30">
          <div dangerouslySetInnerHTML={{ __html: this.props.about }} />
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => ({ about: state.AboutReducer.about });

export default withRouter(connect(mapStateToProps, { getAbout })(About));


// WEBPACK FOOTER //
// ./src/screens/About.js